import { Box, Button } from '@mantine/core';
import { ChevronRight } from 'lucide-react';
import type { FC } from 'react';
import { useHostContext } from '@/context/HostContext.tsx';
import { cn } from '@/utils';
import { STEP_CONTENT_CLASS_NAMES } from '../../../../classNames';

interface StepperWebsiteStepActionsProps {
	isLocked?: boolean;
	isTrainingPending: boolean;
	onTrain: () => void;
}

const StepperWebsiteStepActions: FC<StepperWebsiteStepActionsProps> = ({
	isLocked = false,
	isTrainingPending,
	onTrain
}) => {
	const { localization } = useHostContext();

	return (
		<Box className="mt-4 flex flex-wrap items-center gap-5">
			<Button
				className={cn(STEP_CONTENT_CLASS_NAMES.nextButton, {
					'hover:!bg-gray-200': isLocked
				})}
				classNames={{
					section: 'ml-0',
					label: 'h-auto leading-normal'
				}}
				data-testid="stepper-website-train-button"
				disabled={isTrainingPending || isLocked}
				loading={isTrainingPending}
				onClick={onTrain}
				rightSection={
					<ChevronRight
						aria-hidden="true"
						className="h-4 w-4"
					/>
				}
				type="button"
			>
				{localization.translate(
					'creator',
					'stepperOnboarding.steps.extractWebsiteContent.train'
				)}
			</Button>
		</Box>
	);
};

export default StepperWebsiteStepActions;
